<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="90px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="应付单据号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.payableNo" placeholder="请输入应付单据号"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="单据时间：">
            <el-date-picker v-model="form.createTimeBetween" @change="handleSearchListData" size="mini" type="daterange"
              range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
              unlink-panels clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="支出项：" prop="type">
            <el-select size="mini" v-model="form.type" filterable placeholder="请选择支出项" clearable
              @change="handleSearchListData">
              <el-option v-for="item in spendingList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款人:" prop="user" @change="handleSearchListData">
            <el-select size="mini" v-model="form.user" filterable placeholder="请选择付款人" clearable value-key="userId">
              <el-option v-for="item in userList" :key="item.userId" :label="item.nickname" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" class="plr28" @click="handleAdd">添加</el-button>
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete" plain>删除
        </el-button>
        <span>金额：{{ totalInMoney}}</span>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="payableNo" label="应付单据号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="billDate" label="单据日期" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="typeName" label="财务支出项目" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="money" label="付款金额" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="cardCode" label="卡号" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="payUserName" label="付款人" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="carCode" label="相关车辆" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="propertyUnitName" label="客户" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="content" label="名称" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="passStatusName" label="是否付款" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="passDate" label="付款时间" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" width="100"></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" v-if="scope.row.passStatus == 1"
                @click="handlePass(scope.row)">确认付款</el-button>
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" v-if="scope.row.passStatus == 1"
                @click="handleEdit(scope.row)">编辑</el-button>
              <div class="btn-divide"></div>
              <el-button size="mini" type="text" @click="handleDeleteCause(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <add-cause v-if="addCauseVisible" @cancel="addCauseVisible = false" @confirm="handleAddCauseConfirm"></add-cause>
    <edit-cause v-if="editCauseVisible" :detail="causeDetail" @cancel="editCauseVisible = false"
      @confirm="handleEditCauseConfirm"></edit-cause>
  </div>
</template>

<script>
  import {
    getPayableList,
    deletePayable,
    passPayable,
    userSimpleList
  } from '@/api/Payable'

  import {
    getSpendingList
  } from '@/api/Spending'

  import AddCause from './components/AddCause'
  import EditCause from './components/EditCause'
  export default {
    name: 'MaterialInfo',
    components: {
      AddCause,
      EditCause
    },
    data() {
      return {
        form: {
          createTimeBetween: null,
          payableNo: ""
        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        addCauseVisible: false,
        editCauseVisible: false,
        checkDepartment: false,
        causeDetail: {},
        spendingList: [],
        userList: [],
        totalInMoney: 0
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      }
    },
    created() {
      this.getListData();
      this.handleSpendingList();
      this.handleUserSimpleList();
    },
    methods: {
      async handleUserSimpleList() {
        const res = await userSimpleList({});
        if (res.code === 200) {
          this.total = res.data.total
          this.userList = res.data
        }
      },
      async handleSpendingList() {
        const res = await getSpendingList();
        if (res.code === 200) {
          this.total = res.data.total
          this.spendingList = res.data
        }
      },
      async getListData() {
        this.tableLoading = true
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        if (this.form.createTimeBetween) {
          delete params.createTimeBetween;
          params.billDateEnd = this.form.createTimeBetween[1];
          params.billDateStart = this.form.createTimeBetween[0];
        }
        const res = await getPayableList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
        this.handleTotalInMoney();
      },
      handleTotalInMoney() {
        if (!this.multipleSelection.length) {
          return
        }
        const sum = this.multipleSelection.map(item => item.money).reduce((acc, val) => acc + val, 0);
        this.totalInMoney = sum;
        console.log(sum); // 15
      },
      handleDeleteCause(row) {
        const idList = [row.id]
        this.deletePayable(idList)
      },
      handleCheck(row) {
        this.causeDetail = row
        this.checkDepartment = true
      },
      handleEdit(row) {
        this.causeDetail = row
        this.editCauseVisible = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.id)
        this.deletePayable(idList)
      },
      deletePayable(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deletePayable({
            idList
          })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      handleAdd() {
        this.addCauseVisible = true
      },
      exportCause() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportCause(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      handleAddCauseConfirm() {
        this.addCauseVisible = false
        this.pageIndex = 1
        this.getListData()
      },
      handleEditCauseConfirm() {
        this.editCauseVisible = false
        this.getListData()
      },
      handlePass(row) {
        const idList = [row.id];
        this.$confirm('确定审核通过?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await passPayable({
            idList
          })
          if (res.code === 200) {
            this.$message.success('审核成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/PayableManagement/PayableManagement.vue